export default "__VITE_ASSET__C7dT8ynD__"